import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import API, { setToken } from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=guest, object=authed

  const loadMe = useCallback(async () => {
    try {
      const { data } = await API.get("/auth/me");
      setUser(data.user);
    } catch {
      setUser(null);
    }
  }, []);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await API.post("/auth/login", { email, password });
    if (data.access_token) setToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await API.post("/auth/register", payload);
    return data;
  };

  const verifyEmail = async (email, code) => {
    const { data } = await API.post("/auth/verify-email", { email, code });
    if (data.access_token) setToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const resendOtp = async (email) => {
    const { data } = await API.post("/auth/resend-otp", { email });
    return data;
  };

  const logout = async () => {
    try { await API.post("/auth/logout"); } catch { /* ignore */ }
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, verifyEmail, resendOtp, logout, reload: loadMe }}>
      {children}
    </AuthContext.Provider>
  );
}
